module.exports = __webpack_public_path__ + "img/ecv_en-BE.c5306dbb.svg";